'use client'
import { usePathname } from 'next/navigation'
import { useMemo } from 'react'

export function useCurrentPage(defaultPage = 'home') {
  const pathname = usePathname()

  const currentPage = useMemo(() => {
    if (!pathname) return defaultPage

    const parts = pathname.split('/').filter(Boolean)

    return parts.length >= 2 ? parts[1] : defaultPage
  }, [pathname, defaultPage])

  return { currentPage }
}
